// extracted by mini-css-extract-plugin
export var fadeIn = "_g3-1";
export var modalContent = "_g3-3";
export var overlay = "_g3-0";
export var popoverContent = "_g3-2";
export var results = "_g3-5";
export var searchInputWrapper = "_g3-4";